import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   		from 'FactoryService.js';
import constants        		from 'Constants.js';
import sequenceService  		from 'SequenceService.js';

import ControlModel    		from 'ControlModel.js';
import RankingControlView 		from 'advanced-inputs/RankingControlView.js';

//=============================================================================
//
// Creates a raking control, given a factoryService
// parameter key and a layout position. The factory key defines the initial
//
// Alfonso Cabral, March 4, 2016
//
//=============================================================================
class ControlRankingFactory extends BaseVisualControlFactory {
    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes(  factoryKey, pos ) ;
        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.gridData = [{rank: '0', item: 'Item 1'}, {rank: '1', item: 'Item 2'}, {rank: '2', item: 'Item 3'}];
        attributes.backgroundColor = '#FFFFFF';
        attributes.selectFields = [{text: 'Caption'}];
        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.borderStyle= '~inputBorder';
        attributes.borderSize= '~inputBorder';
        attributes.cornerRadius= '~inputBorder';
        attributes.borderColor = '~inputBorderColor';
        attributes.styleBGColorText = '~inputBgColor';
        attributes.backgroundColor = '~inputBgColor';
        attributes.resizePadding = 2;
        attributes.Property = [
            {
                _id: 'captions',
                Item: [
                    {
                        _value: 'Item 1'
                    },
                    {
                        _value: 'Item 2'
                    },
                    {
                        _value: 'Item 3'
                    }]
            },
            {
                _id: 'ranks',
                Item: [
                    {
                        _value: '1'
                    },
                    {
                        _value: '2'
                    },
                    {
                        _value: '3'
                    }]
            }];
        attributes.minWidth = 10;
        attributes.minHeight = 50;
        attributes.lowestHeight = 50;
        attributes.translateProps = [
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"}
        ];


        return new RankingControlView({
            model: new ControlModel( attributes ),
            el: $(constants.FORM_ID),
            pos: pos,
            factoryKey: factoryKey,
            id: attributes.id
        });
    }

}

const controlRankingFactory = new ControlRankingFactory();
export default controlRankingFactory;